export default class ImagePreviewModel  {
	ImageUrl? = '';
	Width: number;
	Height: number;
	Top: number;
	Left: number;
}



// WEBPACK FOOTER //
// ./~/crop-image/src/ImagePreviewModel.ts